var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page p-patient_add"},[_c('the-dashboard-heading',[_c('h2',[_c('router-link',{attrs:{"to":{ name: 'Patients' }}},[_vm._v("Pacjenci")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.patient.name || 'Nowy pacjent'))])],1)]),_vm._v(" "),_c('the-dashboard-content',[_c('patient-form',{on:{"submit":_vm.savePatient}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }